import styled from 'styled-components';
import {media} from '../../styles/components/media-queries';

export const Wrapper = styled.section`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background-color: #fff;
  border: 0.2rem solid ${props => props.theme.primaryColor};
  border-radius: 0.6rem;
  padding: 1rem 1.4rem 1rem 1.4rem;
  ${media.medium`
    width: calc(100% - 6rem);
    margin: 0 3rem;
  `};
  ${media.small`
    width: calc(100% - 6rem);
    margin: 0 3rem 2rem;
  `};
  ${media.smaller`
    flex-direction: column;
    align-items: flex-start;
    width: calc(100% - 4rem);
    margin: 0 2rem;
    padding: 1rem;
  `};
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  ${media.small`
    flex-direction: column;
    align-items: flex-start;
  `};
  ${media.smaller`
    width: 100%;
  `};
`;

export const Title = styled.h1`
  display: flex;
  align-items: center;
  margin: 0;
  font-size: 1.8rem;
  font-weight: 800;
  white-space: nowrap;
  text-transform: uppercase;
  color: ${props => props.theme.primaryColor};
  &::before {
    font-family: 'icomoon';
    content: '\\e911';
    display: inline-block;
    flex-shrink: 0;
    width: 3.2rem;
    height: 3.2rem;
    line-height: 3.2rem;
    text-align: center;
    font-size: 3.2rem;
    margin-right: 1.2rem;
    color: ${props => props.theme.primaryColor};
  }
  ${media.small`
    padding-bottom: 0.8rem;
  `};
`;

export const Subtitle = styled.p`
  margin: 0;
  padding: 0 2rem;
  font-size: 1.3rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.02rem;
  color: ${props => props.theme.primaryColor};
  opacity: 0.75;
  ${media.medium`
    white-space: normal;
  `};
  ${media.small`
    padding: 0;
  `};
  ${media.smaller`
    display: none;
  `};
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-shrink: 0;
  ${media.smaller`
    width: 100%;
  `};
`;

export const Locator = styled.input`
  width: 16rem;
  height: 4.4rem;
  padding: 0 1.6rem;
  border: 0;
  border-radius: 0.4rem 0 0 0.4rem;
  background-color: ${props => props.theme.primaryColor};
  color: #fff;
  font-size: 1.2rem;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.1rem;
  &::placeholder {
    color: #fff;
    opacity: 0.9;
  }
  &:focus {
    outline: none;
  }
  ${media.smaller`
    width: auto;
    flex: 1;
  `};
`;

export const Go = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 5.6rem;
  height: 4.4rem;
  border-radius: 0 0.4rem 0.4rem 0;
  background-color: ${props => props.theme.secondaryColor};
  color: #fff;
  font-size: 1.3rem;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.1rem;
  cursor: pointer;
  &:hover {
    background-color: ${props => props.theme.secondaryColorHover};
  }
`;
